import React, { useMemo } from 'react';
import './date-time-picker.scss';
import ReactDatePicker from 'react-datepicker';
import { Select } from 'antd';
import ClockIcon from '@svg/clock.svg?react';
import CalendarIcon from '@svg/calendar.svg?react';
import { bottom } from '@popperjs/core';
import moment from 'moment';

interface DateTimePickerProps {
    value: Date;
    onChange: (date: Date) => void;
}

const timeOptions = Array.from({ length: 24 }, (_, i) => {
    const hour = i % 12 === 0 ? 12 : i % 12;
    const period = i < 12 ? 'AM' : 'PM';
    const label = `${hour}:00 ${period}`;
    return { key: i, value: i, label };
});

export const DateTimePicker: React.FC<DateTimePickerProps> = ({ value, onChange }) => {

    const onChangeDate = (date: Date | null) => {
        if (date) {
            const updatedDateTime = new Date(value);
            updatedDateTime.setFullYear(date.getFullYear());
            updatedDateTime.setMonth(date.getMonth());
            updatedDateTime.setDate(date.getDate());

            const now = new Date();
            if (updatedDateTime < now) {
                const nextHour = now.getHours() + 2;
                updatedDateTime.setHours(nextHour, 0, 0, 0);
            }

            onChange(updatedDateTime);
        }
    };

    const onChangeTime = (time: any) => {
        const updatedDateTime = new Date(value);
        updatedDateTime.setHours(time, 0, 0, 0);
        onChange(updatedDateTime);
    };

    const selectedTime = useMemo(() => {
        const currentHour = value.getHours();
        return timeOptions.find(option => option.value === currentHour);
    }, [value]);

    const minDate = useMemo(() => new Date(), []);
    const maxDate = useMemo(() => {
        const date = new Date();
        date.setDate(date.getDate() + 30);
        return date;
    }, []);

    const filteredTimeOptions = useMemo(() => {
        if (value.toDateString() === minDate.toDateString()) {
            const currentHour = new Date().getHours();
            return timeOptions.filter(option => option.value > currentHour);
        }
        return timeOptions;
    }, [value, minDate]);

    return <div className="picker-container">
        <div className="date-picker-wrapper">
            <ReactDatePicker
                selected={value}
                onChange={onChangeDate}
                dateFormat="MMM dd, yyyy"
                showMonthDropdown={false}
                showYearDropdown={false}
                minDate={minDate}
                maxDate={maxDate}
                popperPlacement={bottom}
                calendarClassName="date-picker-component"
                showPopperArrow={false}
                customInput={<div className="date-picker-custom-input">
                    <CalendarIcon/>
                    <label>{moment(value).format('MMM DD, yyyy')}</label>
                    </div>
                }
            />
        </div>
        <div className="time-picker-wrapper">
            <ClockIcon />
            <Select options={filteredTimeOptions}
                    onSelect={(value) => onChangeTime(value)}
                    value={selectedTime}
                    className="time-picker"
                    showArrow={false}
                    popupClassName="dropdown-custom"
            />
        </div>
    </div>;
};